(ns manatee.uuid
  (:require [re-frame.core :as rf]))

(rf/reg-cofx
 :uuid
 (fn [cofx]
   (assoc cofx :uuid (random-uuid))))
